import {
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import {Comic} from "src/app/models/Comic";
import {Manga} from "src/app/models/Manga";
import {isManga, isComic} from "src/app/utils/works-type-guards.util";
import {VolumeProgress} from "src/app/modules/auth/models/User";
import {BaseEditWorkDatesComponent} from "../base-edit-work-dates/base-edit-work-dates.component";
import {ToastService} from "../../services/toast.service";
import {WorksService} from "../../../shared/services/works.service";
import {PaginatedResponse} from "../../../shared/interfaces/ApiResponse.interface";
import {TranslateService, TranslateModule} from "@ngx-translate/core";
import {WorksTypes} from "src/app/enums/Works.enum";
import {EditWorkCompletionDatesComponent} from "../edit-work-completion-dates/edit-work-completion-dates.component";

@Component({
  selector: "app-edit-volumes-dates",
  templateUrl: "./edit-volumes-dates.component.html",
  imports: [EditWorkCompletionDatesComponent, TranslateModule],
})
export class EditVolumesDatesComponent
  extends BaseEditWorkDatesComponent
  implements OnInit, OnChanges
{
  public isManga = isManga;
  public isComic = isComic;
  public comicOrMangaItem!: Comic | Manga;

  constructor(
    translate: TranslateService,
    worksService: WorksService,
    toastService: ToastService,
    cdr: ChangeDetectorRef
  ) {
    super(translate, worksService, toastService, cdr);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.comicOrMangaItem = this.item as Comic | Manga;
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes["item"]?.currentValue) {
      this.comicOrMangaItem = changes["item"].currentValue;
      if (this.user && this.comicOrMangaItem) {
        const getVolumesSubscription = this.worksService
          .getWorks(this.user._id, {
            workId: this.item._id,
            filters: JSON.stringify({
              workType: [
                this.item.type === WorksTypes.Manga
                  ? WorksTypes.Manga
                  : WorksTypes.Comic,
              ],
            }),
          })
          .subscribe({
            next: (item: PaginatedResponse | null) => {
              if (item) {
                this.comicOrMangaItem = {
                  ...this.comicOrMangaItem,
                  progress: (item.data[0] as Comic | Manga).progress,
                  volumes: (item.data[0] as Comic | Manga).volumes,
                };

                if (this.comicOrMangaItem.progress?.volumes) {
                  this.comicOrMangaItem.progress?.volumes.sort((a, b) => {
                    const volumeA = a.volume ?? -Infinity;
                    const volumeB = b.volume ?? -Infinity;
                    return volumeA - volumeB;
                  });
                }
                this.cdr.markForCheck();
              }
            },
          });
        this.subscriptions.push(getVolumesSubscription);
      }
    }
  }

  public getVolumeTitle(volume: number): string {
    if (isComic(this.comicOrMangaItem)) {
      const volumeObject = this.comicOrMangaItem.volumes?.find(
        (comicVolume) => comicVolume.volumeNumber === volume
      );
      return volumeObject?.volumeName ?? "";
    } else {
      return "";
    }
  }

  public trackByNumber(_index: number, item: VolumeProgress): number {
    return item.volume;
  }
}
